module.exports = __webpack_public_path__ + "img/DROP-7-820x1024.5adfd84b.png";